import clsx from 'clsx';

interface DividerProps {
  className?: string;
  theme?: 'singleColor' | 'dualColor';
  color?: string;
}

export function Divider({ className, theme = 'dualColor', color = 'primary' }: DividerProps) {
  return (
    <div className={clsx(className, 'flex items-center')}>
      <div
        className={clsx(
          'w-full border-t bg-opacity-20 h-auto border-b',
          theme === 'dualColor' && 'border-t-darkMode-almostBlack border-b-darkMode-gray-medium/30',
          theme === 'singleColor' && `border-t-${color} border-b-${color}`
        )}
      />
    </div>
  );
}
